import { getCountries, Labels } from 'react-phone-number-input';
import enLabels from 'react-phone-number-input/locale/en.json';
import { AppLocale } from './config';
import { getCountryDisplayName } from './country';

export const getLocalizedPhoneLabels = (locale: AppLocale): Labels => {
  const labels: Labels = { ...enLabels };
  getCountries().forEach((code) => {
    labels[code] = getCountryDisplayName(code, locale);
  });
  return labels;
};
